import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Tasks.css';
import numeral from 'numeral';
import SearchBar from 'components/shared/navigation/SearchBar';
import SimpleTable from 'components/shared/table/SimpleTable';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import SimpleText from 'components/shared/text/SimpleText';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import {
  firstLoadTasksRequest,
  loadTasksRequest,
  openTaskDetails,
} from 'actions/admin/tasks/tasks';
import {
  getCurrentPage,
  getSelectedContractorId,
  getSelectedTradeId,
  getTasks,
  getTrades,
} from 'selectors/admin/tasks/tasks';
import SimpleTaskStatus from 'components/shared/table/cell-addons/SimpleTaskStatus';
import Dropdown from 'components/shared/dropdown/Dropdown';
import SearchableDropDown from 'components/shared/dropdown/SearchableDropDown';
import dropDownArrowPng from 'images/dropdown-arrow.png';
import ContractorsApi from 'services/api/contractors-api';
import { TaskStatusEnum } from 'domain/task-status-enum';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { getCurrentUser } from 'selectors/authentication';
import { usersUtil, TYPES } from 'services/utils/users-util';

export class Tasks extends Component {
  tabSelection = 1;

  componentDidMount() {
    this.props.dispatch(firstLoadTasksRequest());
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handleRowSelection = (index) => {
    this.props.dispatch(openTaskDetails(this.props.tasks.content[index]));
  };

  handleGenerateLink = (id) => {
    const {
      tasks: { content },
    } = this.props;
    const task = content[id];
    return `work-orders/${task.work_order_id}/task/${task.id}`;
  };

  handleTradeChange = (trade) => {
    this.handleChange(
      1,
      this.props.selectedContractorId,
      trade !== null ? trade.value : trade
    );
  };

  handleContractorChange = (contractor) => {
    this.handleChange(
      1,
      contractor !== null ? contractor.value : contractor,
      this.props.selectedTradeId
    );
  };

  handleNavSelect = (id) => {
    this.tabSelection = id;
    this.handleChange(
      1,
      this.props.selectedContractorId,
      this.props.selectedTradeId
    );
  };

  handlePageChange = (newPage) => {
    this.handleChange(
      newPage,
      this.props.selectedContractorId,
      this.props.selectedTradeId
    );
  };

  handleChange = (page, contractorId, tradeId) => {
    switch (this.tabSelection) {
      case 1:
        this.props.dispatch(loadTasksRequest(page, contractorId, tradeId));
        break;

      case 2:
        this.props.dispatch(
          loadTasksRequest(page, contractorId, tradeId, true)
        );
        break;

      case 3:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.DRAFT
          )
        );
        break;

      case 4:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.RFP
          )
        );
        break;

      case 5:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.PLM
          )
        );
        break;

      case 6:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.AGG
          )
        );
        break;

      case 7:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.WOA
          )
        );
        break;

      case 8:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.PRE
          )
        );
        break;

      case 9:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.WIP
          )
        );
        break;

      case 10:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.CMP
          )
        );
        break;

      case 11:
        this.props.dispatch(
          loadTasksRequest(
            page,
            contractorId,
            tradeId,
            undefined,
            TaskStatusEnum.CLS
          )
        );
        break;

      default:
    }
  };

  render() {
    return (
      <div className="tasks">
        <div className="full-title">Tasks</div>

        {this.props.tasks !== null && (
          <div className="content-container">
            <SearchBar>
              <NavigationBar
                items={[
                  {
                    id: 1,
                    title: 'All',
                  },
                  {
                    id: 2,
                    show: this.props.tasks.totalCritical > 0,
                    title: 'Critical',
                    total: this.props.tasks.totalCritical,
                  },
                  {
                    id: 3,
                    show: this.props.tasks.totalDraft > 0,
                    title: 'Draft',
                    total: this.props.tasks.totalDraft,
                  },
                  {
                    id: 4,
                    show: this.props.tasks.totalRfp > 0,
                    title: 'RFP',
                    total: this.props.tasks.totalRfp,
                  },
                  {
                    id: 5,
                    show: this.props.tasks.totalPlm > 0,
                    title: 'PLM',
                    total: this.props.tasks.totalPlm,
                  },
                  {
                    id: 6,
                    show:
                      this.props.tasks.totalAgg > 0 &&
                      (usersUtil.isAdmin(this.props.currentUser) ||
                        usersUtil.hasType(
                          this.props.currentUser,
                          TYPES.GENERAL_CONTRACTOR
                        )),
                    title: 'AGG',
                    total: this.props.tasks.totalAgg,
                  },
                  {
                    id: 7,
                    show: this.props.tasks.totalWoa > 0,
                    title: 'WOA',
                    total: this.props.tasks.totalWoa,
                  },
                  {
                    id: 8,
                    show: this.props.tasks.totalPre > 0,
                    title: 'PRE',
                    total: this.props.tasks.totalPre,
                  },
                  {
                    id: 9,
                    show: this.props.tasks.totalWip > 0,
                    title: 'WIP',
                    total: this.props.tasks.totalWip,
                  },
                  {
                    id: 10,
                    show: this.props.tasks.totalCmp > 0,
                    title: 'CMP',
                    total: this.props.tasks.totalCmp,
                  },
                  {
                    id: 11,
                    show: this.props.tasks.totalCls > 0,
                    title: 'CLS',
                    total: this.props.tasks.totalCls,
                  },
                ]}
                onSelected={this.handleNavSelect}
              />
              <div className="tasks-filter-container">
                <Dropdown
                  className="trade-dropdown"
                  clearable={true}
                  options={this.props.trades.map((trade) => {
                    return {
                      value: trade.id,
                      label: trade.label,
                    };
                  })}
                  placeholder="Filter Trade"
                  value={this.props.selectedTradeId}
                  onChange={this.handleTradeChange}
                />
                <SearchableDropDown
                  arrowRenderer={() => {
                    return <img src={dropDownArrowPng} alt={'arrow'} />;
                  }}
                  autoload={false}
                  className="contractor-dropdown"
                  clearable={true}
                  loadOptions={Tasks.loadContractors}
                  placeholder="Filter Contractor"
                  value={this.props.selectedContractorId}
                  onChange={this.handleContractorChange}
                />
              </div>
            </SearchBar>

            <SimpleTable
              className="tasks-table"
              headers={[
                'WO #',
                'NAME',
                'TASK NAME',
                'LOCATION',
                'STATUS',
                'TRADE',
                'CONTRACTOR',
              ]}
              rows={this.mapTasks(this.props.tasks.content)}
              emptyMessage="No Tasks"
              onRowSelected={this.handleRowSelection}
              onGenerateLink={this.handleGenerateLink}
            />

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={this.props.tasks.pageSize}
                total={this.props.tasks.total}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  mapTasks = (tasks) => {
    return tasks.map((task, index) => {
      // Add special class to hide top border if current task belongs to the same WO of the previous task
      let addClass = false;
      if (index > 0) {
        const previousTask = tasks[index - 1];
        addClass = previousTask.work_order.id === task.work_order.id;
      }

      const rowData = {
        id: index,
        selectable: true,
        data: [
          `${task.work_order.number}-${numeral(task.number).format('00')}`,
          task.work_order.name !== null ? task.work_order.name : 'N/A',
          <span className="h4">{task.name || 'TBD'}</span>,
          <SimpleText
            lines={[
              task.work_order.building.location.street_address_1,
              task.work_order.building.location.city,
            ]}
          />,
          <SimpleTaskStatus status={task.status} />,
          task.trade.label,
          task.contractor_name !== null ? task.contractor_name : 'TBD',
        ],
      };

      if (addClass) {
        rowData['className'] = 'no-top-border';
      }

      return rowData;
    });
  };

  static loadContractors(input) {
    return ContractorsApi.searchContractors(input).then((response) => {
      if (response.ok) {
        return {
          ok: true,
          options: response.contractors.map((element) => {
            return {
              value: element.id,
              label: element.name,
            };
          }),
        };
      } else {
        return {
          ok: false,
          errors: response.errors,
        };
      }
    });
  }
}

export default connect((state) => {
  return {
    currentPage: getCurrentPage(state),
    currentUser: getCurrentUser(state),
    selectedContractorId: getSelectedContractorId(state),
    selectedTradeId: getSelectedTradeId(state),
    tasks: getTasks(state),
    trades: getTrades(state),
  };
})(Tasks);



// WEBPACK FOOTER //
// ./src/components/admin/tasks/Tasks.js